"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "WelcomeOneClick" };
var _hoisted_2 = ["onSubmit"];
var _hoisted_3 = /*#__PURE__*/ vue_2.createElementVNode("h2", { class: "heading2" }, "Ваши данные", -1);
var _hoisted_4 = { class: "submission-form__inputs" };
var _hoisted_5 = { class: "submission-form__grid-2" };
var _hoisted_6 = /*#__PURE__*/ vue_2.createStaticVNode("<div class=\"submission-form__bottom\"><label class=\"checkbox-radio\"><input type=\"checkbox\"><div class=\"checkbox\"><i class=\"termi-circle-checkmark\"></i></div> Я согласен на <a href=\"/terms/\" class=\"link\">обработку персональных данных</a></label><button type=\"submit\" class=\"default-btn\">Отправить</button></div>", 1);
var _hoisted_7 = { class: "form-errors" };
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
var vuex_1 = require("vuex");
var InputContainer_vue_1 = require("vue_components/InputContainer.vue");
var helpers_1 = require("vue_components/helpers");
exports.default = vue_1.defineComponent({
    setup: function (__props) {
        var store = vuex_1.useStore();
        var router = vue_router_1.useRouter();
        var formErrors = vue_3.ref([]);
        var form = vue_3.ref({
            person_type: { value: 'fiz' },
            name: {
                placeholder: 'ФИО',
                required: true,
                value: ''
            },
            email: {
                type: 'email',
                pattern: helpers_1.inputProperties.email.pattern,
                placeholder: 'E-mail',
                required: true,
                value: ''
            },
            phone: {
                type: 'tel',
                pattern: helpers_1.inputProperties.tel.pattern,
                placeholder: '+7 (XXX) XXX-XX-XX*',
                required: true,
                value: ''
            }
        });
        function checkout() {
            return __awaiter(this, void 0, void 0, function () {
                var formData, res, errors;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            formErrors.value.length = 0;
                            formData = helpers_1.formToFormData(form.value);
                            return [4 /*yield*/, store.dispatch('postData', { url: '/order/checkout/', formData: formData })];
                        case 1:
                            res = _a.sent();
                            errors = res.data.errors;
                            if (Array.isArray(errors)) {
                                errors.forEach(function (i) { return formErrors.value.push(JSON.stringify(i)); });
                                throw errors;
                            }
                            router.push(res.data.data.url);
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_1, [
                vue_2.createElementVNode("form", {
                    class: "submission-form",
                    onSubmit: vue_2.withModifiers(checkout, ["prevent"])
                }, [
                    _hoisted_3,
                    vue_2.createElementVNode("div", _hoisted_4, [
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "name",
                            placeholder: form.value.name.placeholder,
                            required: form.value.name.required,
                            modelValue: form.value.name.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((form.value.name.value) = $event); })
                        }, null, 8, ["placeholder", "required", "modelValue"]),
                        vue_2.createElementVNode("div", _hoisted_5, [
                            vue_2.createVNode(InputContainer_vue_1.default, {
                                type: "tel",
                                name: "phone",
                                pattern: form.value.phone.pattern,
                                placeholder: form.value.phone.placeholder,
                                required: form.value.phone.required,
                                modelValue: form.value.phone.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((form.value.phone.value) = $event); })
                            }, null, 8, ["pattern", "placeholder", "required", "modelValue"]),
                            vue_2.createVNode(InputContainer_vue_1.default, {
                                type: form.value.email.type,
                                name: "email",
                                pattern: form.value.email.pattern,
                                placeholder: form.value.email.placeholder,
                                required: form.value.email.required,
                                modelValue: form.value.email.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((form.value.email.value) = $event); })
                            }, null, 8, ["type", "pattern", "placeholder", "required", "modelValue"])
                        ])
                    ]),
                    _hoisted_6,
                    vue_2.createElementVNode("div", _hoisted_7, [
                        (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(formErrors.value, function (error) {
                            return (vue_2.openBlock(), vue_2.createElementBlock("div", null, vue_2.toDisplayString(error), 1));
                        }), 256))
                    ])
                ], 40, _hoisted_2)
            ]));
        };
    }
});
